import { render, staticRenderFns } from "./ModelosCombustible.vue?vue&type=template&id=488d427c&scoped=true"
import script from "./ModelosCombustible.vue?vue&type=script&lang=js"
export * from "./ModelosCombustible.vue?vue&type=script&lang=js"
import style0 from "./ModelosCombustible.vue?vue&type=style&index=0&id=488d427c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488d427c",
  null
  
)

export default component.exports